// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperPreviewList-cls1_Mnq","cls2":"PaperPreviewList-cls2_YmP PaperPreviewList-cls1_Mnq"};